import React from "react";
import {Box, Chip, Colors, Text} from "@bounce/shared/ui";
import {CATEGORY_FALLBACK_CONDITIONS_LABEL, CATEGORY_FALLBACK_DESCRIPTION} from "./constants";

const CategoryFallbackCard = () => (
  <Box
    sx={{
      width: "100%",
      backgroundColor: Colors.tertiary._100,
      borderRadius: "12px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
    }}
  >
    <Text variant="interDisplay600" size={16} sx={{color: Colors.grey._800}}>
      Conditions
    </Text>
    <Chip size_="small" variant_="inherit" label={CATEGORY_FALLBACK_CONDITIONS_LABEL} />
    <Text size={12} sx={{color: Colors.grey._600}}>
      {CATEGORY_FALLBACK_DESCRIPTION}
    </Text>
  </Box>
);

export default CategoryFallbackCard;
